import { ApiError } from './ApiError'
import { HttpRequest } from '../interfaces/http'
import { NetworkErrorCode } from '../interfaces/error/NetworkErrorCode'
import { ErrorCategory } from '../interfaces/error/ErrorCategory.Enum'

// Map error code to message
const getMessage = (code: NetworkErrorCode): string => {
  if (code === NetworkErrorCode.NET_INTERNET_DISCONNECTED) return 'no internet connection'
  // eslint-disable-next-line max-len
  if (code === NetworkErrorCode.NET_REQUEST_TIMEOUT) return 'no response from server within time limit'
  if (code === NetworkErrorCode.NET_NO_RESPONSE) return 'no response from server'
  if (code === NetworkErrorCode.NET_UNKNOWN) return 'unknown error'
  // fallback:
  return `${code} (no message specified for this error code)`
}

// Map error code to Category
const getCat = (code: NetworkErrorCode): ErrorCategory => {
  if (code === NetworkErrorCode.NET_INTERNET_DISCONNECTED) return ErrorCategory.INTERNET_DOWN
  // eslint-disable-next-line max-len
  if (code === NetworkErrorCode.NET_REQUEST_TIMEOUT) return ErrorCategory.REQUEST_TIME_OUT
  if (code === NetworkErrorCode.NET_NO_RESPONSE) return ErrorCategory.SERVER_NO_RESPONSE
  if (code === NetworkErrorCode.NET_UNKNOWN) return ErrorCategory.UNKNOWN
  // fallback:
  return ErrorCategory.UNKNOWN
}

/**
 * A NetworkError is returned/thrown when we can't get network access
 * to the api's url, e.g. the server doesn't respond or the internet is
 * disconnected.
 *
 * Inspect the error code/message for the reason.
 */
export class NetworkError extends ApiError {
  constructor(args: {
    code: NetworkErrorCode;
    httpRequest: HttpRequest;
    originalError: Error;
  }) {
    const myMessage = `Network error: ${getMessage(args.code)}`
    const cat = getCat(args.code)
    let excerptExtra: {[key: string]: unknown} | undefined
    if (args.code === NetworkErrorCode.NET_REQUEST_TIMEOUT) {
      if (args.httpRequest.timeout) {
        excerptExtra = { 'time-limit': `${args.httpRequest.timeout.toString()} ms` }
      }
    } else {
      excerptExtra = undefined
    }
    super({
      message: myMessage, ...args, excerptExtra, category: cat,
    })
    Object.setPrototypeOf(this, NetworkError.prototype)
  }
}
